module.exports = __webpack_public_path__ + "static/image-laughing-51786a8cf04b44b022a7bfdd9d1f5502.jpg";